<template>
  <div class="questionnaire-paper" :class="{'error': questionnaireDestory}">
    <template v-if="dataDone && !questionnaireDestory">
      <page-progress />
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">最近一次就诊医院</span></div>
        <div class="anwser">
             <input type="text" class="questionnaire-input" v-ios-bug-fixed placeholder="请输入最近一次线下就诊医院名称" v-model="hospital">
        </div>
      </div>
      <!-- 科室 -->
      <div class="questionnaire-item selector" @click="getDepartmentData">
        <div class="qusetion-title"><span class="required">最近一次就诊科室</span></div>
        <div class="anwser">
          <div class="selector-tips" v-if="!departmentShowText">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="selector-value" v-else>{{departmentMainText}} - {{departmentShowText}}</div>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">疾病名称</span></div>
        <div class="anwser">
             <input type="text" class="questionnaire-input" v-ios-bug-fixed placeholder="线下就诊确定的疾病名称" v-model="disease">
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span class="required">症状变化</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="change" placeholder="上次治疗后，最主要症状的变化，比如疾病发作的位置、范围、性质、程度、频率等的变化"
            maxlength="100"></textarea>
          <span class="limit">{{change.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>疗法反馈</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="feedback" v-ios-bug-fixed placeholder="请对上次用药效果做出评价" maxlength="100"></textarea>
          <span class="limit">{{feedback.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item selector" @click="relieveShow = true">
        <div class="qusetion-title"><span>是否得到缓解</span></div>
        <div class="anwser">
          <div class="selector-tips" v-if="!relieve">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="selector-value" v-else>{{this.relieve}}</div>
        </div>
      </div>

      <div class="questionnaire-item">
        <div class="qusetion-title"><span>本次就诊急需改善的症状</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="improve" v-ios-bug-fixed placeholder="本次就诊最急迫希望医生能帮您解决的问题,请说明"
            maxlength="100"></textarea>
          <span class="limit">{{improve.length}}/100</span>
        </div>
      </div>

      <div class="questionnaire-item">
        <div class="qusetion-title"><span>其他不舒服或希望治疗的症状</span></div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="uncomfortable" v-ios-bug-fixed placeholder="上次治疗后，是否有其他不舒服或希望治疗的症状？如有请说明"
            maxlength="100"></textarea>
          <span class="limit">{{uncomfortable.length}}/100</span>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title">既往病史</div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="sickpast" v-ios-bug-fixed placeholder="既往是否患有高血压、高脂血症、糖尿病、冠心病等其他系统重大疾病，若没有请填“无”" maxlength="100"></textarea>
          <span class="limit">{{sickpast.length}}/100</span>
        </div>
        <!--
        <div class="quick-selector">
          <div class="quick-item" v-for="item in pastData" @click="quickInput('sickPast', item)">{{item}}</div>
        </div>
        -->
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title">传染病史</div>
        <div class="anwser">
          <textarea class="questionnaire-text" v-model="infectious" v-ios-bug-fixed placeholder="是否有肝炎、结核病史，若没有请填“无”" maxlength="100"></textarea>
          <span class="limit">{{infectious.length}}/100</span>
        </div>

      </div>
      <!--正常上传-->

      <div class="questionnaire-item" v-if="!jsApiShow">
        <div class="qusetion-title"><span class="required">上传舌面、舌底照片</span></div>
        <div class="anwser">
          <div class="upload-wrapper">
            <!-- 上传舌面照 -->
            <div class="upload-item uploader" id="uploadTongueFront">
              <div class="uploader-box" v-if="!tongueFrontPreview">
                <icon icon-class="upload-thin"></icon>
                <span>上传舌面照</span>
              </div>
              <div class="preview-box" v-else>
                <img :src="tongueFrontPreview">
                <div class="upload-status" :class="{'done': tongueFrontFile.status == 5}" v-if="tongueFrontFile && tongueFrontFile.status">{{tongueFrontFile.status | uploadStatus}}</div>
              </div>
            </div>
            <div class="upload-item uploader" id="uploadTongueBack">
              <div class="uploader-box" v-if="!tongueBackPreview">
                <icon icon-class="upload-thin"></icon>
                <span>上传舌底照</span>
              </div>
              <div class="preview-box" v-else>
                <img :src="tongueBackPreview">
                <div class="upload-status" :class="{'done': tongueBackFile.status == 5}" v-if="tongueBackFile && tongueBackFile.status">{{tongueBackFile.status | uploadStatus}}</div>
              </div>
            </div>
          </div>
          <div class="upload-tips">
            <p>请使用后置摄像头并关闭美颜功能，每次复诊时请尽量在相同的光源环境下拍摄以避免环境差异造成的影响。</p>
            <p>拍照前请不要食用或饮用可导致舌苔颜色变化的饮食物，不要刮苔。</p>
            <p>请面向自然光线，将口尽量张大，放松地将舌伸出并拍照，然后将舌卷起，舌尖轻抵上颚，暴露舌下脉络并拍照，一次拍照时间过长时，请休息几分钟再行拍照，以免舌头暴露时间过长而失真。</p>
            <p>请同时上传舌面及舌底照片。</p>
          </div>
        </div>
      </div>
      <!--jssdk上传-->
      <div class="questionnaire-item" v-else>
        <div class="qusetion-title"><span class="required">上传舌面、舌底照片</span></div>
        <div class="anwser">
          <div class="upload-wrapper">
            <!-- 上传舌面照 -->
            <div class="upload-item uploader" @click="wxTongueFrontUpload()">
              <div class="uploader-box" v-if="!tongueFrontPreview">
                <icon icon-class="upload-thin"></icon>
                <span>上传舌面照</span>
              </div>
              <div class="preview-box" v-else>
                <img :src="tongueFrontPreview">
                <div class="upload-status" :class="{'done': tongueFrontFile.status == 5}" v-if="tongueFrontFile && tongueFrontFile.status">{{tongueFrontFile.status | uploadStatus}}</div>
              </div>
            </div>
            <div class="upload-item uploader" @click="wxTongueBackUpload()">
              <div class="uploader-box" v-if="!tongueBackPreview">
                <icon icon-class="upload-thin"></icon>
                <span>上传舌底照</span>
              </div>
              <div class="preview-box" v-else>
                <img :src="tongueBackPreview">
                <div class="upload-status" :class="{'done': tongueBackFile.status == 5}" v-if="tongueBackFile && tongueBackFile.status">{{tongueBackFile.status | uploadStatus}}</div>
              </div>
            </div>
          </div>
          <div class="upload-tips">
            <p>请使用后置摄像头并关闭美颜功能，每次复诊时请尽量在相同的光源环境下拍摄以避免环境差异造成的影响。</p>
            <p>拍照前请不要食用或饮用可导致舌苔颜色变化的饮食物，不要刮苔。</p>
            <p>请面向自然光线，将口尽量张大，放松地将舌伸出并拍照，然后将舌卷起，舌尖轻抵上颚，暴露舌下脉络并拍照，一次拍照时间过长时，请休息几分钟再行拍照，以免舌头暴露时间过长而失真。</p>
            <p>请同时上传舌面及舌底照片。</p>
          </div>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>上传面象及病患处照片</span><em>最多上传9张</em></div>
        <div class="anwser">
          <div class="upload-wrapper">
            <div class="upload-item" v-for="(item, index) in faceOssList">
              <span class="delPic" v-if="item.status == 5" @click="delFaceImage(item)">
                <icon icon-class="close"></icon>
              </span>
              <div class="preview-box">
                <img :src="item.url" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
                <div class="image-done" v-else>上传成功</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="wxFaceUploadCount>0">
              <div class="uploader-box" @click="wxFaceImgUpload()">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
          <div class="upload-tips">
            <p>请使用后置摄像头并关闭美颜功能，每次复诊时请尽量在相同的光源环境下拍摄以避免环境差异造成的影响。</p>
            <p>拍照前请不要化妆。</p>
            <p>请面向自然光线拍照。</p>
          </div>
        </div>
      </div>
      <div class="questionnaire-item">
        <div class="qusetion-title"><span>上传新的检查结果及报告</span><em>最多上传9张</em></div>
        <div class="anwser">
          <div class="upload-wrapper">
            <div class="upload-item" v-for="(item, index) in reportOssList">
              <span class="delPic" v-if="item.status == 5" @click="delReportImage(item)">
                <icon icon-class="close"></icon>
              </span>
              <div class="preview-box">
                <img :src="item.url" alt="">
                <div class="image-status" v-if="item.status != 5">上传中</div>
                <div class="image-done" v-else>上传成功</div>
              </div>
            </div>
            <div class="upload-item uploader" v-show="wxReportUploadCount>0">
              <div class="uploader-box" @click="wxReportImgUpload()">
                <icon icon-class="upload-thin"></icon>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="next-wrapper">
        <button class="next-button" @click="nextStep">下一步</button>
      </div>

      <!-- 弹出层 -->
      <!-- 是否缓解 -->
      <van-popup v-model="relieveShow" position="bottom">
        <van-picker show-toolbar :columns="relieveData" value-key="label" @cancel="relieveShow = false" @confirm="confirmRelieve" />
      </van-popup>
      <!-- 科室选择 -->
      <van-popup v-model="departmentPickerShow" position="bottom" title="选择科室" class="department-selector">
        <van-tree-select :items="departmentData" :main-active-index="departmentMainActiveIndex" :active-id="departmentActiveId"
          @navclick="navClick" @itemclick="itemClick" />
      </van-popup>
    </template>
    <div class="error-page questionnaire" v-if="dataDone && questionnaireDestory">
      <icon icon-class="fail"></icon>
      <p>问诊单不存在</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .questionnaire-paper{
    position: relative;
    z-index: 15;
    padding: 32px 16px 0;
    &.error{
      margin-top: -92px;
    }
    .questionnaire-item{
      margin-bottom: 40px;
      .quick-selector{
        padding-top: 8px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: wrap;
        .quick-item{
          margin: 12px 3px 0 0;
          background: #FAFAFA;
          font-size: 14px;
          line-height: 14px;
          color: #666;
          padding: 5px 6px;
          height: 36px;
          border-radius: 4px;
        }
      }
      &.selector{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .anwser{
          margin-top: 0;
          .selector-tips{
            font-size: 16px;
            line-height: 16px;
            color: #999;
            svg{
              color: #CCC;
            }
          }
          .selector-value{
            font-size: 16px;
            line-height: 16px;
            color: #333;
          }
        }
      }
      .qusetion-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        .required{
          position: relative;
          &::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            margin-left: 2px;
            font-size: 16px;
            color: @error;
          }
        }
        em{
          margin-left: 8px;
          font-size: 14px;
          color: #999;
        }
      }
      .anwser{
        margin-top: 12px;
        position: relative;
        .questionnaire-text{
          border: 1px solid #F7F7F7;
          background: #F7F7F7;
          resize: none;
          padding: 12px;
          font-size: 14px;
          line-height: 20px;
          color: #666;
          width: 100%;
          height: 96px;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .questionnaire-input{
          border: 1px solid #F7F7F7;
          background: #F7F7F7;
          resize: none;
          padding: 12px;
          font-size: 14px;
          line-height: 20px;
          color: #666;
          width: 100%;
          height: 36px;
          &::-webkit-input-placeholder{
            color: #999;
          }
        }
        .limit{
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 12px;
          color: #999;
        }

        .upload-wrapper{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-wrap: wrap;
          margin-bottom: -16px;
          .upload-item{
            position: relative;
            width: 96px;
            height: 96px;
            margin: 0 16px 16px 0;
            &:nth-child(3n){
              margin-right: 0
            }
            &.uploader{
              .uploader-box{
                width: 100%;
                height: 100%;
                border: 1px dashed #CCC;
                background: #F3F3F3;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                border-radius: 4px;
                svg{
                  font-size: 28px;
                  color: #CCC;
                }
                span{
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 8px;
                  color: #CCC;
                }
              }
              .preview-box{
                position: relative;
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
                // width: 156px;
                width: 100%;
                height: 96px;
                border-radius: 4px;
                overflow: hidden;
                img{
                  width: 100%;
                }
                .upload-status{
                  position: absolute;
                  left: 0;
                  bottom: 0;
                  width: 100%;
                  height: 24px;
                  color: #FFF;
                  font-size: 12px;
                  line-height: 24px;
                  text-align: center;
                  background: rgba(0, 0, 0, .4);
                  transition: all .2s;
                  &.done{
                    background: @xile;
                  }
                }
              }
            }
            .preview-box{
              position: relative;
              width: 100%;
              height: 100%;
              overflow: hidden;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              border-radius: 4px;
              background: #000;
              img{
                width: 100%;
              }
              .image-status{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 20px;
                line-height: 20px;
                background: rgba(0, 0, 0, .5);
                color: #FFF;
                text-align: center;
                font-size: 12px;
              }
              .image-done{
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 20px;
                line-height: 20px;
                 background: @xile;;
                color: #FFF;
                text-align: center;
                font-size: 12px;
              }
            }
            .delPic{
              position: absolute;
              top: -8px;
              right: -8px;
              width: 20px;
              height: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #DDD;
              border-radius: 50%;
              background: #FFF;
              z-index: 20;
              svg{
                font-size: 12px;
                color: #999;
              }
            }
          }
        }
        .upload-tips{
          margin-top: 16px;
          padding: 12px;
          font-size: 12px;
          line-height: 16px;
          color: #666;
          border: 1px solid #F7F7F7;
          background: #FAFAFA;
          border-radius: 4px;
          p{
            margin-bottom: 8px;
            &:last-child{
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .next-wrapper{
      padding: 24px 24px 12px;
      background: #F7F7F7;
      margin: 0 -16px;
      .next-button{
        @button-base();
        width: 100%;
        height: 40px;
      }
    }
  }
</style>

<script type="text/javascript">
  import pageProgress from '@/components/Common/pageScrollProgress'
  export default {
    data() {
      return {
        testjsApiFlag: false,
        jsApiShow: false,
        dataDone: false,
        questionnaireDestory: false,
        questionnaireId: this.$route.query.id,
        // 变化
        change: '',
        // 反馈
        feedback: '',
        // 缓解
        relieve: '',
        relieveData: ['是', '否'],
        relieveShow: false,
        //希望改善的症状
        improve: '',
        // 不舒服
        uncomfortable: '',
        // 舌面照
        tongueFrontUploader: null,
        tongueFrontPreview: '',
        tongueFrontFile: {},
        // 舌背照
        tongueBackUploader: null,
        tongueBackPreview: '',
        tongueBackFile: {},
        // 上传面像
        faceUploader: null,
        faceImgList: [],
        faceOssList: [],
        wxFaceUploadLocalArray: [],
        wxFaceUploadServerArray: [],
        wxFaceUploadCount: 9,
        wxFaceUploadStatus: false,
        // 上传检查报告
        reportUploader: null,
        reportImgList: [],
        reportOssList: [],
        wxReportUploadLocalArray: [],
        wxReportUploadServerArray: [],
        wxReportUploadCount: 9,
        wxReportUploadStatus: false,
        //新增字段

        disease:'',
        hospital:'',
        // 科室
        department: '',
        departmentData: [],
        departmentPickerShow: false,
        departmentMainActiveIndex: 0,
        departmentMainText: '',
        departmentActiveId: null,
        departmentShowText: '',

        // 既往病
        sickpast: '',
        //传染病
        infectious:'',
        // 既往病史
        //pastData: ['无', '高血压病', '高脂血症', '糖尿病', '冠心病', '心律失常', '心肌梗塞', '心力衰竭', '脑梗死', '脑出血', '慢性支气管炎', '慢性阻塞性肺疾病', '肺源性心脏病', '支气管哮喘', '支气管扩张症', '消化道溃疡', '反流性食管炎', '胆结石', '脂肪肝', '肝硬化', '慢性肾小球肾炎', '肾病综合征', '肾功能衰竭', '甲状腺功能亢进症', '甲状腺功能减退症', '痛风', '帕金森病', '乙型病毒性肝炎', '结核病', '重大外伤史', '重大手术史', '输血史'],

      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    components: {
      pageProgress
    },
    created() {
      let _this = this;
      this.$root.post('/getDepartmentList').then(data => {
        this.departmentData = data;

      })
      //加载jssdk
      let url = encodeURIComponent(window.location.href.split('#')[0])
      this.$root.post('/getJsSdk', {
        // url: `${window.location.protocol}//${window.location.host}/`
        url: url
      }).then(data => {
        if (data) {
          wx.config({
            debug: this.$store.state.wechatDebug,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['chooseImage', 'uploadImage']
          });

        }

      })
      _this.getAnswerData()

    },
    methods: {
      // 快速选择选项
      quickInput(type, item) {
        // 字数即将大于最大值时取消操作
        let text = this[type] + `，${item}`;
        if(text.length >= 100) return;
        if(this[type]) {
          this[type] += `，${item}`;
        }else {
          this[type] = item;
        }
      },
      // 点击选择科室
      getDepartmentData() {
        if (this.departmentData.length == 0) {
          // get data
        }
        this.departmentPickerShow = true;
      },
      // 点击科室一级
      navClick(index) {
        this.departmentMainActiveIndex = index;
        // this.departmentMainText = this.departmentData[index].text;
      },
      itemClick(data) {
        console.log(data);
        this.departmentActiveId = this.department = data.id;
        this.departmentShowText = data.text;
        this.departmentPickerShow = false;
        this.departmentData.forEach((items, index) => {
          if (items.children) {
            items.children.forEach(item => {
              if (item.id == data.id) {
                this.departmentMainText = items.text;
              }
            })
          }
        })
      },
      wxReportSyncUpload() {
        let _this = this;
        if (_this.wxReportUploadLocalArray.length == 0) {
          _this.wxReportUploadStatus = false;
        } else {
          var entry = _this.wxReportUploadLocalArray.shift();
          _this.wxReportUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxReportUploadServerArray.push(serverId);

              _this.reportOssList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'patient',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.reportOssList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })


              _this.wxReportSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxReportImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxReportUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxReportUploadStatus = true;
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxReportUploadLocalArray.push(entry);
              _this.reportOssList.push(entry);
            });

            _this.wxReportSyncUpload();

          }
        });

      },
      delReportImage(item) {
        let _this = this;
        let index = _this.reportOssList.indexOf(item)
        _this.reportOssList.splice(index, 1);
        _this.wxReportUploadCount += 1;
      },
      //面向9张照片
      wxFaceSyncUpload() {
        let _this = this;
        if (_this.wxFaceUploadLocalArray.length == 0) {
          _this.wxFaceUploadStatus = false;
        } else {
          var entry = _this.wxFaceUploadLocalArray.shift();
          _this.wxFaceUploadCount -= 1;
          wx.uploadImage({
            localId: entry.localid,
            isShowProgressTips: 0,
            success: function(res) {
              var serverId = res.serverId
              _this.wxFaceUploadServerArray.push(serverId);

              _this.faceOssList.forEach(item => {
                if (item.localid == entry.localid) {
                  item.serverid = serverId
                }
              });
              console.log("上传第" + entry.localid + '张')

              _this.$root.post('/getWxImg', {
                id: serverId,
                oss_dir: 'patient',
                filename: serverId,
                type: 1
              }).then(data => {
                console.log("返回服务端数据")
                console.log(data)
                if (data.status == 1) {
                  _this.faceOssList.forEach(item => {
                    if (item.serverid == serverId) {
                      item.url = data.url;
                      item.status = 5;
                    }
                  });

                } else {
                  _this.$notify('发送图片失败');
                }
              })


              _this.wxFaceSyncUpload();
            },
            fail(err) {
              console.log('error');
              _this.$toast.clear();
              _this.$notify(`上传图片报错${JSON.stringify(err)}`);
            }
          });
        }

      },
      wxFaceImgUpload() {
        let _this = this;
        wx.chooseImage({
          count: _this.wxFaceUploadCount, // 默认9
          sizeType: ['compressed'],
          sourceType: ['album', 'camera'],
          success: function(res) {
            _this.wxFaceUploadStatus = true;
            res.localIds.forEach(item => {
              var entry = {
                status: 1,
                localid: item,
                url: item,
                serverid: ''
              };
              _this.wxFaceUploadLocalArray.push(entry);
              _this.faceOssList.push(entry);
            });

            _this.wxFaceSyncUpload();

          }
        });

      },
      delFaceImage(item) {
        let _this = this;
        let index = _this.faceOssList.indexOf(item)
        _this.faceOssList.splice(index, 1);
        _this.wxFaceUploadCount += 1;
      },
      getAnswerData() {
        let _this = this;
        // 获取回显数据
        this.$root.post('/getAnswerDetail', {
          type: 1,
          id: this.questionnaireId
        }).then(data => {
          console.log(data);
          if (data.status == 1) {
            // 正常
            this.dataDone = true;
            this.questionnaireDestory = false;
            // 数据回显
            this.hospital=data.hospital||'';
            this.disease=data.disease||'';
            if (data.dep_id) {
              this.department = data.dep_id;
              this.departmentData.forEach((items, index) => {
                if (items.children) {
                  items.children.forEach(item => {
                    if (item.id == this.department) {
                      this.departmentActiveId = item.id;
                      this.departmentMainActiveIndex = index;
                      this.departmentMainText = items.text;
                      this.departmentShowText = item.text;
                    }
                  })
                }
              })
            }
            this.change = data.sym_change || '';
            this.feedback = data.couple_back || '';
            this.relieve = data.is_anesis == 3 ? '' : (data.is_anesis == 1 ? '是' : '否');
            this.improve = data.improve || '';
            this.uncomfortable = data.symptom || '';
            this.infectious=data.infectious||'';
            this.sickpast=data.sickpast||'';
            if (data.tongue_img) {
              this.tongueFrontPreview = data.tongue_img[0];
              this.$set(this.tongueFrontFile, 'path', data.tongue_img[0]);
              this.tongueBackPreview = data.tongue_img[1];
              this.$set(this.tongueBackFile, 'path', data.tongue_img[1]);
            }
            //
            if (data.face_img.length > 0) {
              data.face_img.forEach(item => {
                this.faceOssList.push({
                  url: item,
                  status: 5
                })
              })
              if (data.face_img.length >= 9) {
                this.wxFaceUploadCount = 0;
              } else {
                this.wxFaceUploadCount = 9 - parseInt(data.face_img.length);
              }
            } else {
              this.faceOssLis = [];
            }

            //
            if (data.result_img.length > 0) {
              data.result_img.forEach(item => {
                this.reportOssList.push({
                  url: item,
                  status: 5
                })
              })
              if (data.result_img.length >= 9) {
                this.wxReportUploadCount = 0;
              } else {
                this.wxReportUploadCount = 9 - parseInt(data.result_img.length);
              }
            } else {
              this.reportOssList = [];
            }

            //this.faceOssList = data.face_img || [];
            //this.reportOssList = data.result_img || [];
            /*
            if (this.faceOssList.length > 0) {
              this.faceOssList.forEach(item => {
                this.faceImgList.push({
                  url: item,
                  status: 5
                })
              })
            }

            if (this.reportOssList.length > 0) {
              this.reportOssList.forEach(item => {
                this.reportImgList.push({
                  previewImage: item,
                  status: 5
                })
              })
            }
            */
            wx.checkJsApi({
              jsApiList: ['chooseImage', 'uploadImage'],
              success: function(res) {
                console.log(res.checkResult)
                if (res.checkResult.chooseImage && res.checkResult.uploadImage) {
                  //if (_this.userInfo.user_id == 10036) {
                  //  console.log('俩接口正确')
                  //  _this.jsApiShow = true;
                  // }
                  _this.jsApiShow = true;
                  // 初始化图片上传
                }
                // 初始化图片上传
                _this.$nextTick(() => {
                  if (!_this.jsApiShow) {
                    console.log('初始化原生上传功能')
                    // 单张上传
                    _this.setUpload(_this.tongueFrontUploader, 'uploadTongueFront', 'tongueFrontFile',
                      'tongueFrontPreview');
                    _this.setUpload(_this.tongueBackUploader, 'uploadTongueBack', 'tongueBackFile',
                      'tongueBackPreview');
                  }
                  // 多张上传
                  // _this.setMultipleUpload(_this.faceUploader, 'faceUploader', 'faceImgList','faceOssList');
                  // _this.setMultipleUpload(_this.reportUploader, 'reportUploader', 'reportImgList','reportOssList');
                })
              }
            });

          } else if (data.status == 2) {
            // 问诊单已被删除
            this.dataDone = true;
            this.questionnaireDestory = true;
          } else if (data.status == 0) {
            // 已完成的问诊单
            this.$router.replace({
              path: '/patient/record/detail',
              query: {
                type: 2,
                id: this.questionnaireId
              }
            });
          }
        })

      },
      //舌面照片
      wxTongueFrontUpload() {
        let _this = this;
        var int = 0;
        var serverIdArr = new Array();
        var localIdArr = new Array();

        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {

            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            _this.tongueFrontPreview = localIds[int].toString();
            _this.tongueFrontFile.status = 1;
            localIdArr = localIds;
            wx.uploadImage({ //根据本地ID获得微信服务器ID
              localId: localIds[int].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 0, // 默认为1，显示进度提示
              success: function(res) {
                var serverId = res.serverId; // 返回图片的服务器端ID
                console.log("serverid:" + serverId)
                _this.$root.post('/getWxImg', {
                  id: serverId,
                  oss_dir: 'patient',
                  type: 1
                }).then(data => {
                  if (data.status == 1) {
                    _this.tongueFrontFile.path = data.url;
                    _this.tongueFrontPreview = data.url;
                    _this.tongueFrontFile.status = 5;
                  } else {
                    _this.$notify('发送图片失败');
                  }
                })


              },
              fail(err) {
                console.log('error');
                _this.$toast.clear();
                _this.$notify(`上传图片报错${JSON.stringify(err)}`);
              }
            });
          }
        });

      },
      //舌底照片
      wxTongueBackUpload() {
        let _this = this;
        var int = 0;
        var serverIdArr = new Array();
        var localIdArr = new Array();


        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function(res) {

            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
            _this.tongueBackFile.status = 1;
            _this.tongueBackPreview = localIds[int].toString();
            localIdArr = localIds;
            wx.uploadImage({ //根据本地ID获得微信服务器ID
              localId: localIds[int].toString(), // 需要上传的图片的本地ID，由chooseImage接口获得
              isShowProgressTips: 0, // 默认为1，显示进度提示
              success: function(res) {
                var serverId = res.serverId; // 返回图片的服务器端ID
                console.log("serverid:" + serverId)
                _this.$root.post('/getWxImg', {
                  id: serverId,
                  oss_dir: 'patient',
                  type: 1
                }).then(data => {
                  if (data.status == 1) {
                    _this.tongueBackFile.path = data.url;
                    _this.tongueBackPreview = data.url;
                    _this.tongueBackFile.status = 5;
                  } else {
                    _this.$notify('发送图片失败');
                  }
                })


              },
              fail(err) {
                console.log('error');
                _this.$toast.clear();
                _this.$notify(`上传图片报错${JSON.stringify(err)}`);
              }
            });
          }
        });

      },
      // 上传单张函数
      setUpload(obj, id, file, preview) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,jpeg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 单文件上传
          multi_selection: false,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              console.log(files);
              let canUploadFiles = 0;
              files.forEach(file => {
                if (file.type.indexOf("image/") == -1) {
                  //_this.$notify('图片格式不正确');
                  //up.removeFile(file)
                  // return false;
                  canUploadFiles++
                } else {
                  canUploadFiles++
                  let fileName = file.name;
                  _this.$root.previewUploadImage(file, (imgSrc) => {
                    _this[preview] = imgSrc;
                  })
                }
              })

              if (canUploadFiles == files.length) {
                _this[file] = files[0];
                _this.$root.setUploadParam(up, '', false, 'patient');
                console.log(_this[file])
              }
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true, 'patient');
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this[file].path = res.path
                //上传成功后直接用结果图作为预览
                _this[preview] = res.thumb;
                // _this.avatar = res.path;
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 上传多张张函数
      // 上传多张张函数
      setMultipleUpload(obj, id, file, finalList) {
        let _this = this;
        obj = new plupload.Uploader({
          runtimes: 'html5,flash,silverlight,html4',
          browse_button: id,
          flash_swf_url: '/view/index/template/src/assets/js/plupload/js/Moxie.swf',
          silverlight_xap_url: '/view/index/template/src/assets/js/plupload/js/Moxie.xap',
          url: 'http://oss.aliyuncs.com',
          // 不检测重复文件
          filters: {
            // mime_types: [
            //   {title: "image", extensions: "jpg,jpeg,webp,png,bmp"}
            // ],
            // prevent_duplicates: true,
          },
          // 多文件上传
          multi_selection: true,
          init: {
            // 选择文件之后
            FilesAdded(up, files) {
              // 获取当前已上传的图片数量
              let objLength = _this[file].length;
              let canUploadFiles = 0
              files.forEach(item => {
                // 如果本次选中的图片数量超出了9张的限制，则自动删除多出的图片
                if (item.type.indexOf("image/") == -1) {
                  _this.$notify('图片格式不正确');
                  up.removeFile(item)
                  return false;
                } else {
                  objLength++;
                  canUploadFiles++;
                  if (objLength > 9) {
                    up.removeFile(item);
                  };
                  let fileName = item.name;
                  _this.$root.previewUploadImage(item, (imgSrc) => {
                    item.previewImage = imgSrc;
                    _this[file].push(item);
                  })
                }
              })
              if (canUploadFiles == files.length) {
                _this.$root.setUploadParam(up, '', false, 'patient');
              }
            },
            // 上传前设置文件名
            BeforeUpload(up, fileObj) {
              _this.$root.setUploadParam(up, fileObj.name, true, 'patient');
            },
            // 上传完成
            FileUploaded(up, fileObj, info) {
              if (info.status == 200) {
                let res = JSON.parse(info.response);
                _this[finalList].push(res.path)
                // _this.avatar = res.path;
              }
            },
            Error(up, err) {
              console.log(err);
            }
          }
        })
        // 初始化上传
        obj.init();
      },
      // 确认是否缓解
      confirmRelieve(value) {
        this.relieve = value;
        this.relieveShow = false;
      },
      // 删除已上传的图片
      delPic(item, obj, ossObj) {
        let index = this[obj].indexOf(item)
        this[obj].splice(index, 1);
        this[ossObj].splice(index, 1);
      },
      nextStep() {
        if (!this.hospital) {
          this.$notify('请填写最近一次就诊医院');
          return;
        }
        if (!this.department) {
          this.$notify('请填写最近一次就诊科室');
          return;
        }
        if (!this.disease) {
          this.$notify('请填写疾病名称');
          return;
        }
        if (!this.change) {
          this.$notify('请填写症状变化');
          return;
        }
        if ((!this.tongueFrontFile || !this.tongueFrontFile.path) || (!this.tongueBackFile || !this.tongueBackFile.path)) {
          this.$notify('请上传舌面舌底照片');
          return;
        }
        if (this.wxReportUploadStatus) {
          this.$notify('请等待所有图片上传完成');
          return;
        }
        if (this.wxFaceUploadStatus) {
          this.$notify('请等待所有图片上传完成');
          return;
        }
        var face_img = [];
        if (this.faceOssList.length > 0) {
          this.faceOssList.forEach(item => {
            if (item.status == 5) {
              face_img.push(item.url);
            }

          });
        }

        var result_img = [];
        if (this.reportOssList.length > 0) {
          this.reportOssList.forEach(item => {
            if (item.status == 5) {
              result_img.push(item.url);
            }
          });
        }
        console.log(face_img)
        let postData = {
          id: this.questionnaireId,
          hospital:this.hospital,
          dep_id:this.department,
          disease:this.disease,
          sym_change: this.change,
          couple_back: this.feedback,
          is_anesis: this.relieve ? (this.relieve == '是' ? 1 : 2) : 3,
          symptom: this.uncomfortable,
          improve: this.improve,
          tongue_img: [this.tongueFrontFile.path, this.tongueBackFile.path],
          face_img: face_img,
          result_img: result_img,
          infectious:this.infectious,
          sickpast:this.sickpast

        }
        console.log(postData);
        this.$root.post('/addPatientAnswer', postData).then(data => {
          console.log(data);
          if (data.status == 1) {
            this.$router.push({
              path: '/patient/questionnaire/step-two',
              query: {
                id: this.questionnaireId
              }
            });
          } else {
            this.$notify(data.msg);
          }
        })

      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Questionnaire/stepOne.vue